import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import { useAmplitude } from "react-amplitude-hooks";
import { numberWithCommas, stringToDate } from "components/Travel/function";
import { countryName } from "components/Travel/country";
import { LookedButtonSmall } from "style/components";

interface Props {
  data: any;
  index: number;
  match: any;
}

const ListCard: React.FunctionComponent<Props> = ({ data, index, match }) => {
  const { logEvent } = useAmplitude();
  return (
    <LastTrip first={index === 0 ? true : false} className="lastTripBox">
      <CardTitle>
        <h3 className="destination">{countryName(data.travelInfo.country)}</h3>
        <Link
          to={`${match.url}/list/${index}`}
          onClick={() => logEvent("history_detail_button")}
        >
          <LookedButtonSmall>상세보기</LookedButtonSmall>
        </Link>
      </CardTitle>

      <Definition className="first">
        <dt>가입일시</dt>
        <dd>{data.insuranceDate}</dd>
      </Definition>
      <Definition>
        <dt>보험기간</dt>
        <dd>
          <span className="number">{stringToDate(data.policyStartDate)}</span> (
          <span className="number">{data.policyStartDateTime}</span>시)
          <span> ~ </span>
          <span className="number">{stringToDate(data.policyEndDate)}</span> (
          <span className="number">{data.policyEndDateTime}</span>시)
        </dd>
      </Definition>
      <Definition>
        <dt>가입인원</dt>
        <dd>
          <span className="number">
            {data.travelInfo.companionInfoList.length}
          </span>
          명
        </dd>
      </Definition>
      <Definition>
        <dt>보험료</dt>
        <dd>{numberWithCommas(data.totalAmount)}원</dd>
      </Definition>
    </LastTrip>
  );
};

const Definition = styled.dl`
  display: flex;
  align-items: center;
  margin-top: 16px;

  .lastTripBox & {
    margin-top: 10px;
  }

  &.first {
    margin-top: 0;
  }

  > dt {
    width: 90px;
    font-weight: ${props => props.theme.weight.bolder};
  }

  .number {
    font-family: ${props => props.theme.fonts.number};
    font-weight: 300;
  }
`;

interface ConfirmBoxProps {
  first?: boolean;
}
const LastTrip = styled.div<ConfirmBoxProps>`
  padding: 30px 20px;
  border-top: 1px solid ${props => (props.first ? "#070e1a" : "#efefef")};
`;

const CardTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;

  .destination {
    font-weight: ${props => props.theme.weight.bolder};
    font-size: ${props => props.theme.history.sizeFont};
  }
`;

export default ListCard;
